import React, { useState,useEffect, useRef } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  Label,
  FormFeedback,
  Alert,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAppSettings } from '../../contexts/AppSettingsContext';
import { login } from "../../api/authApi";
import bgLoginImage from "../../assets/images/backgroundimage.jpg"

const Login = (props) => {
  const { appSettings } = useAppSettings()
  const appName = appSettings?.title || process.env.REACT_APP_APP_NAME;
  // #State
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const backgroundRef = useRef(null);

  useEffect(() => {
     // Only set styles on backgroundRef element
     if (backgroundRef.current && appSettings?.login_bg_image) {
      const imageUrl = appSettings.login_bg_image.replace(/ /g, "%20");
      backgroundRef.current.style.backgroundImage = `url(${imageUrl || bgLoginImage})`;
      backgroundRef.current.style.backgroundSize = 'cover';
      backgroundRef.current.style.backgroundPosition = 'center';
      backgroundRef.current.style.height = '100vh';
      backgroundRef.current.style.display = 'flex';
      backgroundRef.current.style.justifyContent = 'center';
    }
  }, [appSettings.login_bg_image]);


  const navigate = useNavigate();

  // Function for password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Login field validation 
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .required("Please Enter Your Username")
        .matches(/^\S+$/, "Spaces are not allowed"),
      password: Yup.string()
        .required("Please Enter Your Password")
        .matches(/^\S+$/, "Spaces are not allowed"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  // Function handle login functionality
  async function handleSubmit(values) {
    try {
      let response = await login(values);

      if (response?.code == 200) {
        const { code, message, token, data } = response;
       
        localStorage.setItem("authToken", token);
        localStorage.setItem("authUser", JSON.stringify(data));
        setErrorMessage("");
        setSuccessMessage(message);
        navigate("/dashboard");
      } else {
        setSuccessMessage("");
        setErrorMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  }


  return (
    <React.Fragment>
      <div ref={backgroundRef} className="bg-overlay login-bg">
        <div className="auth-pages my-5 pt-5">
          <Container>
            <Row className="justify-content-center login-box">
              <Col lg={6} md={8} xl={4}>
                <Card>
                  <CardBody className="p-4">
                    <div>
                      <div className="text-center">
                        <Link to="/">
                          <img
                            src={appSettings?.logo || ""}
                            alt=""
                            height="50"
                            className="auth-logo logo-dark mx-auto"
                          />
                   
                        </Link>
                      </div>
                      <h4 className="font-size-18 text-muted mt-2 text-center">
                        Welcome to {appName}!
                      </h4>
                      <p className="mb-5 text-center">
                        Sign in to continue with {appName}.
                      </p>
                      <Form
                        className="form-horizontal"
                        onSubmit={formik.handleSubmit}
                      >
                        {errorMessage && (
                          <Alert color="danger">
                            <div>{errorMessage}</div>
                          </Alert>
                        )}
                        {successMessage && (
                          <Alert color="success">
                            <div>{successMessage}</div>
                          </Alert>
                        )}
                        <Row>
                          <Col md={12}>
                            <div className="mb-4">
                              <Label className="form-label">Username</Label>
                              <Input
                                name="username"
                                type="text"
                                placeholder="Enter User name"
                                value={formik.values.username}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={
                                  formik.touched.username &&
                                  formik.errors.username
                                    ? true
                                    : false
                                }
                              />
                              {formik.touched.username &&
                              formik.errors.username ? (
                                <span className="invalidError">
                                  {formik.errors.username}
                                </span>
                              ) : null}
                            </div>
                            <div className="mb-4">
                              <Label className="form-label">Password</Label>
                              <div className="input-group">
                                <Input
                                  name="password"
                                  type={showPassword ? "text" : "password"}
                                  placeholder="Enter Password"
                                  value={formik.values.password}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  invalid={formik.touched.password && !!formik.errors.password}
                                />
                                <button
                                  className="btn btn-outline-secondary"
                                  type="button"
                                  onClick={togglePasswordVisibility}
                                >
                                  {showPassword ? (
                                    <i
                                      className="ri-eye-off-fill"
                                      style={{ fontSize: "15px" }}
                                    ></i>
                                  ) : (
                                    <i
                                      className="ri-eye-fill"
                                      style={{ fontSize: "15px" }}
                                    ></i>
                                  )}
                                </button>
                              </div>
                              {formik.touched.password &&
                              formik.errors.password ? (               
                                  <span className="invalidError">{formik.errors.password}</span>
                              ) : null}
                            </div>

                            <div className="d-grid mt-4">
                              <span className="text-muted">
                                <Link
                                  to="/forgot-password"
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                    cursor: "pointer",
                                  }}
                                >
                                  <i className="mdi mdi-lock"></i> Forgot your
                                  password?
                                </Link>
                              </span>
                            </div>
                            <div className="d-grid mt-4">
                              <button
                                className="btn btn-primary waves-effect waves-light"
                                type="submit"
                              >
                                Log In
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
